import { iconPath } from '@ui/helpers'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import css from 'styled-jsx/css'
import Tooltip from './Tooltip'
import { PackageTrackingStatus } from '../order/enum'

interface ITrackingSteps {
  tracking?: Types.ParcelInfo
  paid_date?: Date
}

enum Color {
  ACTIVATED = 'var(--activated)',
  PENDING = 'var(--pending)',
  DEFAULT = 'var(--default)',
  CANCEL = 'var(--canceled)'
}

enum Icon {
  CHECKED = 'checked.svg',
  PENDING = 'pending.svg',
  CANCEL = 'canceled.svg'
}

const TrackingSteps = ({ tracking, paid_date }: ITrackingSteps) => {
  const [histories, setHistories] = useState((): Types.DoHistory[] => [
    {
      active: true,
      name: 'Confirmed',
      icon: iconPath(Icon.CHECKED),
      time: paid_date,
      color: Color.DEFAULT
    },
    {
      active: false,
      name: 'Processing',
      color: Color.DEFAULT
    },
    {
      active: false,
      name: 'Shipped',
      color: Color.DEFAULT
    },
    {
      active: false,
      name: 'Delivered',
      color: Color.DEFAULT
    }
  ])

  const getDateDisplay = (date?: number | Date | undefined) => {
    if (!date) return ''
    return dayjs(date)
  }

  const setTimeLine = (status?: string, tracking?: Types.ParcelInfo) => {
    if (!status) return
    //status = 'IN_PROCESSING'
    switch (status) {
      case PackageTrackingStatus.CANCELLED:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Canceled',
            icon: iconPath(Icon.CANCEL),
            time: getDateDisplay(tracking?.cancel_at),
            color: Color.CANCEL
          },
          { active: false, name: 'Processing', color: Color.DEFAULT },
          { active: false, name: 'Delivered', color: Color.DEFAULT }
        ])
        break
      case PackageTrackingStatus.IN_WAITING:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          { active: false, name: 'Processing', color: Color.DEFAULT },
          { active: false, name: 'Shipped', color: Color.DEFAULT },
          { active: false, name: 'Delivered', color: Color.DEFAULT }
        ])
        break
      case PackageTrackingStatus.IN_PROCESSING:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Processing',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.processing_at),
            color: Color.ACTIVATED
          },
          { active: false, name: 'Shipped', color: Color.DEFAULT },
          { active: false, name: 'Delivered', color: Color.DEFAULT }
        ])
        break
      case PackageTrackingStatus.IN_REVIEW:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Pending',
            icon: iconPath(Icon.PENDING),
            time: getDateDisplay(tracking?.pending_at),
            color: Color.PENDING
          },
          { active: false, name: 'Shipped', color: Color.DEFAULT },
          { active: false, name: 'Delivered', color: Color.DEFAULT }
        ])
        break
      case PackageTrackingStatus.ON_DELIVERY:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Processing',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.processing_at),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Shipped',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.tracking_date?.tracking_available_date),
            color: Color.ACTIVATED
          },
          { active: false, name: 'Delivered', color: Color.DEFAULT }
        ])
        break
      case PackageTrackingStatus.IN_DELAY:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Processing',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.processing_at),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Shipped',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.tracking_date?.tracking_available_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Delay',
            icon: iconPath(Icon.PENDING),
            color: Color.PENDING,
            isTooltipDisable: true
          }
        ])
        break
      case PackageTrackingStatus.UNDELIVERABLE:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Processing',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.processing_at),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Shipped',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(
              tracking?.tracking_date?.tracking_delivered_date ||
                tracking?.tracking_date?.tracking_online_date ||
                tracking?.tracking_date?.tracking_available_date
            ),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Undeliverable',
            icon: iconPath(Icon.PENDING),
            color: Color.PENDING,
            isTooltipDisable: true
          }
        ])
        break
      case PackageTrackingStatus.DELIVERED:
        setHistories([
          {
            active: true,
            name: 'Confirmed',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(paid_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Processing',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.processing_at),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Shipped',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.tracking_date?.tracking_available_date),
            color: Color.ACTIVATED
          },
          {
            active: true,
            name: 'Delivered',
            icon: iconPath(Icon.CHECKED),
            time: getDateDisplay(tracking?.tracking_date?.tracking_delivered_date),
            color: Color.ACTIVATED
          }
        ])
        break
    }
  }

  const renderStep = (history: Types.DoHistory) => {
    const textColor = history.color
    return (
      <>
        <div className="step-marker">
          <figure
            className={`image ${history.name === 'Partial Delivered' ? 'steps--partial' : ''}
              `}
          >
            <img src={history.icon} alt="" />
          </figure>
        </div>
        <div className="step-details">
          <p className="step-title is-size-7-touch" style={{ color: textColor }}>
            {history.name}
          </p>
          {history.time && (
            <p className="step-title__time" style={{ color: textColor }}>
              {dayjs(history.time).format('MMM DD, YYYY')}
            </p>
          )}
        </div>
      </>
    )
  }

  const stepInfo = (history: Types.DoHistory) => {
    return (
      <>
        <p style={{ fontSize: 12, fontWeight: 600 }}>{history.name}</p>
        <p style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
          {history.time ? dayjs(history.time).format('HH:MM:ss - D/M/YY') : 'Not Yet'}
        </p>
      </>
    )
  }

  useEffect(() => {
    setTimeLine(tracking?.status, tracking)
  }, [tracking])

  return (
    <div className="steps">
      <style jsx global>
        {globalStyle}
      </style>
      {histories.map((history) => (
        <div key={history.name} className={`step-item ${history.active ? 'steps--activated' : ''}`}>
          <Tooltip
            alignArrowLeft={46}
            contentColor={history.active ? '#fff' : '#ababab'}
            backgroundColor={history.color}
            containerContent={renderStep(history)}
            active={!history.isTooltipDisable}
          >
            {stepInfo(history)}
          </Tooltip>
        </div>
      ))}
    </div>
  )
}

const globalStyle = css.global`
  .steps {
    --default: #e0e3e9;
    --activated: #5bb3e4;
    --canceled: #eb5757;
    --pending: #f2994a;

    color: var(--activated);

    &--canceled {
      color: var(--canceled);
    }

    &--pending {
      color: var(--pending);
    }

    &--activated {
      color: var(--activated);
    }

    &--partial {
      background: #fff;
      width: 27px;
      height: 27px;
    }

    //@media screen and (min-width: 1200px) {
    .step-item {
      min-width: 25%;
    }
    //}

    .step-marker {
      width: 40px !important;
      height: 40px !important;
      border: 8px solid #fff !important;
      background: #e0e3e9 !important;
    }

    .step-title {
      font-size: 10px !important;
      line-height: 16px !important;
      font-weight: bold !important;
      margin-top: 8px;
      color: #ababab;

      &__time {
        font-size: 10px !important;
        line-height: 16px !important;
        white-space: nowrap;
      }
    }

    .step-item:not(:first-child)::before {
      height: 4px;
      width: 88px;
      left: -40px;
      top: 18px;
      border-radius: 16px;
      background: var(--default);
    }

    .step-item.steps--activated::before {
      background: var(--activated) !important;
    }

    .step-details {
      padding-left: 8px;
    }
  }
`

export default TrackingSteps
